module.exports = function() {
  return new Worker(__webpack_public_path__ + "9a1d85af1f44e74bef5c.worker.js");
};